import { render } from "./PatientNavigation.vue?vue&type=template&id=76a487c5&lang=pug"
import script from "./PatientNavigation.vue?vue&type=script&lang=js"
export * from "./PatientNavigation.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__